import service from './service';
import uri from '../variables/uri';
import history from '../history';

class Api {
    constructor() {
        if (!!Api.instance) {
            return Api.instance;
        }

        Api.instance = this;

        this.token = undefined;

        return this;
    }

    get = (uri, headers = undefined) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.token === '') await this.getToken();
                const response = await service.get(uri, {
                    headers: {
                        'Application-Authorization': `Bearer ${this.token}`,
                        Authorization: `Basic ${btoa(localStorage.getItem('username') + ':' + localStorage.getItem('password'))}`,
                        ...headers
                    }
                });
                resolve(response);
            } catch (ex) {
                if(ex.response != null && ex.response !== undefined){
                    if(ex.response.status === 401){
                        this.responseUnauth();
                    }
                }
                reject(ex);
            }
        });
    }

    post = (uri, body, headers = undefined) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.token === '') await this.getToken();
                const response = await service.post(uri, body, {
                    headers: {
                        'Application-Authorization': `Bearer ${this.token}`,
                        Authorization: `Basic ${btoa(localStorage.getItem('username') + ':' + localStorage.getItem('password'))}`,
                        ...headers
                    }
                });
                resolve(response);
            } catch (ex) {
                if(ex.response != null && ex.response !== undefined){
                    if(ex.response.status === 401){
                        this.responseUnauth();
                    }
                }
                reject(ex);
            }
        });
    }

    getToken = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await service.get(uri.GET_TOKEN, {
                    headers: {
                        Authorization: `Basic ${btoa(localStorage.getItem('username') + ':' + localStorage.getItem('password'))}`
                    }
                });
                this.token = response.data.token;
                resolve(response);
            } catch (ex) {
                reject(ex);
            }
        });
    }

    customAutoLogin = (uri, body, headers = undefined) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await service.post(uri, body, {
                    headers: {
                        //Authorization: `2769bcb0-fad1-4de8-83da-95d51bbb4e53`,
                        Authorization: `0d2d986a-5ebe-444c-8d85-ce4c6cbf9da2`,
                        ...headers
                    }
                });
                this.token = response.data.token;
                resolve(response);
            } catch (ex) {
                if(ex.response != null && ex.response !== undefined){
                    if(ex.response.status === 401){
                        this.responseUnauth();
                    }
                }
                reject(ex);
            }
        });
    }

    responseUnauth() {
        history.push('/');
    }
}

export default new Api();